import React, { useMemo } from 'react'
import {
  ContextMenuItem,
  createContextMenuComponent,
  ContextMenuComponentProps,
} from 'react-datasheet-grid'
import { useTranslation } from 'react-i18next'

export const ContextMenu: React.FC<ContextMenuComponentProps> = (props) => {
  const { t } = useTranslation()
  const contextMenu = useMemo(
    () =>
      createContextMenuComponent(((item: ContextMenuItem) => {
        switch (item.type) {
          case 'CUT':
            return t('actions.cut')
          case 'COPY':
            return t('actions.copy')
          case 'PASTE':
            return t('actions.paste')
          case 'DELETE_ROW':
          case 'DELETE_ROWS':
            return t('actions.deleteRow')
          case 'DUPLICATE_ROW':
          case 'DUPLICATE_ROWS':
            return t('actions.duplicateRow')
          case 'INSERT_ROW_BELLOW':
            return t('actions.insertRowBelow')
          default:
            return ''
        }
      }) as any),
    [t]
  )
  return contextMenu(props)
}
